import { useState } from "react";
import { AppAlertProps } from "./AppAlert";

export interface UseAppAlertState {
    open: boolean;
}

export interface UseAppAlertActions {
    showAlert: () => void;
    hideAlert: () => void;
}

export interface UseAppAlertResult {
    state: UseAppAlertState;
    actions: UseAppAlertActions;
    appAlertProps: AppAlertProps;
}

export function useAppAlert(): UseAppAlertResult {
    const [open, setOpen] = useState<boolean>(false);

    const state: UseAppAlertState = {
        open,
    };

    const actions: UseAppAlertActions = {
        showAlert() {
            setOpen(true);
        },
        hideAlert() {
            setOpen(false);
        },
    };

    const appAlertProps: AppAlertProps = {
        open,
        onClose: actions.hideAlert,
    };

    return {
        state,
        actions,
        appAlertProps,
    };
}

export default useAppAlert;
